import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationLeadTodoProfilApiService } from './organization-lead-todo-profil-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationLeadTodoProfilApiService extends GeneratedOrganizationLeadTodoProfilApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
